import { CURRENCIES, CURRENCIES_TIME_SERIES } from "src/common/constants";
import {
  CurrenciesAction,
  Currency,
  CurrencyRatesPayload,
  CurrencySelections,
} from "../reducers/currencies";

export const CURRENCIES_FETCH_DATA = `${CURRENCIES}_GET_DATA` as const;
export const CURRENCIES_FETCH_INVOKED = `${CURRENCIES}_GET_INVOKED` as const;
export const CURRENCIES_FETCH_SUCCESS = `${CURRENCIES}_GET_SUCCESS` as const;
export const CURRENCIES_FETCH_FAILED = `${CURRENCIES}_GET_FAILED` as const;

export type FetchCurrenciesI = { type: typeof CURRENCIES_FETCH_DATA };
export type FetchCurrenciesInvokedI = {
  type: typeof CURRENCIES_FETCH_INVOKED;
};
export type FetchCurrenciesSuccessI = {
  type: typeof CURRENCIES_FETCH_SUCCESS;
  payload: Currency[];
};
export type FetchCurrenciesFailedI = {
  type: typeof CURRENCIES_FETCH_FAILED;
  error: Error;
};

export const fetchCurrencies = () => ({ type: CURRENCIES_FETCH_DATA });
export const fetchCurrenciesInvoked = () => ({
  type: CURRENCIES_FETCH_INVOKED,
});
export const fetchCurrenciesSuccess = (payload: Currency[]) => ({
  type: CURRENCIES_FETCH_SUCCESS,
  payload,
});
export const fetchCurrenciesFailed = (error: Error) => ({
  type: CURRENCIES_FETCH_FAILED,
  error,
});

export const CURRENCIES_TIME_SERIES_FETCH_DATA =
  `${CURRENCIES_TIME_SERIES}_GET_DATA` as const;
export const CURRENCIES_TIME_SERIES_FETCH_INVOKED =
  `${CURRENCIES_TIME_SERIES}_GET_INVOKED` as const;
export const CURRENCIES_TIME_SERIES_FETCH_SUCCESS =
  `${CURRENCIES_TIME_SERIES}_GET_SUCCESS` as const;
export const CURRENCIES_TIME_SERIES_FETCH_FAILED =
  `${CURRENCIES_TIME_SERIES}_GET_FAILED` as const;

export type FetchCurrenciesTimeSeriesI = {
  type: typeof CURRENCIES_TIME_SERIES_FETCH_DATA;
  selections: CurrencySelections;
};
export type FetchCurrenciesTimeSeriesInvokedI = {
  type: typeof CURRENCIES_TIME_SERIES_FETCH_INVOKED;
};
export type FetchCurrenciesTimeSeriesSuccessI = {
  type: typeof CURRENCIES_TIME_SERIES_FETCH_SUCCESS;
  payload: CurrencyRatesPayload;
};
export type FetchCurrenciesTimeSeriesFailedI = {
  type: typeof CURRENCIES_TIME_SERIES_FETCH_FAILED;
  error: Error;
};

export const fetchCurrenciesTimeSeries = (
  selections: CurrencySelections
): CurrenciesAction => ({
  type: CURRENCIES_TIME_SERIES_FETCH_DATA,
  selections,
});
export const fetchCurrenciesTimeSeriesInvoked = (): CurrenciesAction => ({
  type: CURRENCIES_TIME_SERIES_FETCH_INVOKED,
});
export const fetchCurrenciesTimeSeriesSuccess = (
  payload: CurrencyRatesPayload
): CurrenciesAction => ({
  type: CURRENCIES_TIME_SERIES_FETCH_SUCCESS,
  payload,
});
export const fetchCurrenciesTimeSeriesFailed = (
  error: Error
): CurrenciesAction => ({
  type: CURRENCIES_TIME_SERIES_FETCH_FAILED,
  error,
});

export const CURRENCIES_SET_SELECTIONS =
  `${CURRENCIES}_SET_SELECTIONS` as const;

export type CurrenciesSetSelectionsI = {
  type: typeof CURRENCIES_SET_SELECTIONS;
  selections: CurrencySelections;
};

export const setSelections = (selections): CurrenciesAction => ({
  type: CURRENCIES_SET_SELECTIONS,
  selections,
});
